import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaChartLine, FaDumbbell } from "react-icons/fa";

const SelectionPage = () => {
  return (
    <div className="min-h-screen  flex items-center justify-center px-6">
      <div className="max-w-5xl w-full mx-auto">
        <div className="grid md:grid-cols-2 gap-6 mx-auto">
          {/* Track Game Card */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.1 }}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
            className="h-full"
          >
            <Link to="/tracking" className="block h-full">
              <div className="bg-primary rounded-xl p-8 h-full border border-test/10 hover:border-test/30 transition-all duration-300 relative overflow-hidden group shadow-md hover:shadow-xl">
                <div className="absolute inset-0 bg-gradient-to-br from-test/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative z-10">
                  <div className="bg-test/10 w-14 h-14 rounded-lg flex items-center justify-center mb-6">
                    <FaChartLine className="w-7 h-7 text-test" />
                  </div>
                  <h2 className="text-2xl font-semibold text-test mb-4">
                    Tracking
                  </h2>
                  <p className="text-white/70 mb-6 text-base leading-relaxed">
                    <div class="tracking-step">
                      <h2>Measure Your Current Skill</h2>
                      <p>
                        Throw 99 darts to build or update your digital twin and
                        get fresh insights into your accuracy, strengths, and
                        improvement areas.
                      </p>
                      <small>
                        <em>
                          (Tip: A short warm-up is recommended before starting.)
                        </em>
                      </small>
                    </div>
                  </p>
                  <div className="mt-2 inline-flex items-center text-test text-sm font-medium">
                    Start tracking
                    <span className="ml-2 transform group-hover:translate-x-1.5 transition-transform duration-300">
                      →
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </motion.div>

          {/* Training Card (Coming Soon) */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
            className="relative h-full"
          >
            <div className="bg-primary rounded-xl p-8 h-full border border-test/10 opacity-50 relative overflow-hidden shadow-md">
              <div className="absolute inset-0 backdrop-blur-[1px]" />
              <div className="relative z-10">
                <div className="bg-test/10 w-14 h-14 rounded-lg flex items-center justify-center mb-6">
                  <FaDumbbell className="w-7 h-7 text-test" />
                </div>
                <h2 className="text-2xl font-semibold text-test mb-4">
                  Training
                </h2>
                <p className="text-white/70 mb-6 text-base leading-relaxed">
                  <div class="training-step">
                    <h2>Train Smarter, Based on Real Data</h2>
                    <p>
                      Start with a quick tracking session (optional) to spot
                      your current pain points.
                    </p>
                    <p>
                      Then, get a personalized 15-minute training plan tailored
                      to your needs, designed to target exactly where you can
                      improve the fastest.
                    </p>
                    <small>
                      <em>
                        (Tip: Your session will also update your progress
                        history.)
                      </em>
                    </small>
                  </div>
                </p>
                <div className="absolute top-6 right-6 bg-test/10 px-3 py-1.5 rounded-md">
                  <span className="text-test text-sm font-medium">
                    Coming Soon
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default SelectionPage;
